import { Dialog } from '@capacitor/dialog'

export const DialogService = {
	async alert(message, title = 'Avviso') {
		await Dialog.alert({ title, message })
	},

	async confirm(options) {
		const result = await Dialog.confirm({
			title: options.title || 'Conferma',
			message: options.message,
			okButtonTitle: options.okButtonTitle || 'Si',
			cancelButtonTitle: options.cancelButtonTitle || 'No'
		})
		return result.value
	}
}
